import { createFileRoute } from "@tanstack/react-router";
import Contact from "@/pages/Contact";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/contact/")({
  head: () => routeHead("/uk/contact/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Contact />
  );
}
